import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClientDashboardView from '../components/views/ClientDashboard';
import {
  getProjectMonthReportStatistic, getProjectMonthStatistic,
} from '../redux/actions';
import { selectors } from '../redux/selectors/projects';
import type {
  Project, ProjectStatistics, State, User,
} from '../types';

type Props = {
  projects: Array<Project>,
  currentUser: User,
  navigate: object,
  onGetProjectMonthStatistic: Function,
  onGetProjectMonthReportStatistic: Function,
  projectStatistics: ProjectStatistics,
  location: object,
};

class ClientDashboard extends Component<Props> {
  render(): React.ReactNode {
    return (
      <ClientDashboardView {...this.props} />
    );
  }
}

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  projects: selectors.getDashboardProjects(state),
  projectStatistics: state.projectStatistics,
});

const mapDispatchToProps = dispatch => ({
  onGetProjectMonthStatistic: (year: number, month: number, projectId: number) => dispatch(getProjectMonthStatistic(year, month, projectId)),
  onGetProjectMonthReportStatistic: (year: number, month: number, projectId: number) => dispatch(getProjectMonthReportStatistic(year, month, projectId)),
});

const ConnectedClientDashboard = connect(mapStateToProps, mapDispatchToProps)(ClientDashboard as any);

export default ConnectedClientDashboard;
